import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store/app.state';
import * as moment from 'moment';
import { ConfigService } from '../../../config/config.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { GetTrainingEventsAction } from '../../../store/training/actions';
import { EventStatus, ITrainingDto } from '../../../services/bpp.webapi/client';
import { AppInsightClientService } from '../../../services/app-insight.service';
import { BaseComponent } from '../../base-component/base.component';
import { takeUntil } from 'rxjs/operators';
import { StatusHelper } from '../../../helpers/statuses-helper';
import { FilterPanelByClubDaterangeComponent } from '../../filter-panel-by-club-date-range/filter-panel-by-club-daterange.component';
import { filterTrainings } from '../../../helpers/trainings-helper';

@Component({
  selector: 'app-trainings-broadcasters-table',
  templateUrl: './trainings-broadcasters-table.component.html'
})
export class TrainingsBroadcastersTableComponent extends BaseComponent implements OnInit, OnDestroy {
  private filterPanel: FilterPanelByClubDaterangeComponent;
  @ViewChild('filterPanel', { static: false }) set panel(filterPanel: FilterPanelByClubDaterangeComponent) {
    if (filterPanel) {
      this.filterPanel = filterPanel;
    }
  }

  userSubscription: Subscription;
  items: Array<ITrainingDto>;
  trainings: Array<ITrainingDto>;
  user: any;
  isLoading = false;

  constructor(private store: Store<AppState>,
    private config: ConfigService,
    private appInsightsService: AppInsightClientService,
    private router: Router) {
    super();
    this.isLog = config.isDebug();
  }

  ngOnInit() {
    this.items = [];
    this.trainings = [];

    this.store
      .select(e => e.trainings.result)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(res => {
        this.isLoading = res.loading;

        if (res && res.items && res.items instanceof Array) {
          this.items = res.items;
          this.filterData();
        }
      });

    this.userSubscription = this.store.select(store => store.user.currentUser).subscribe(user => {
      if (user && user.role) {
        this.user = user;
        this.store.dispatch(new GetTrainingEventsAction(user.role));
      }
    });
  }

  navigateToDetail(item: ITrainingDto) {
    if (StatusHelper.isCompeletedEvent(item, moment().utc()) === true) {
      return;
    }
    this.appInsightsService.logEvent('Training details', {
      trainingId: item.id
    });
    this.router.navigate([`trainings/detail/${item.id}`], { queryParams: {club: item.club}});
  }

  getStateColor(item: ITrainingDto) {
    return StatusHelper.getStatusColor(item.status);
  }

  onClubSelected() {
    this.filterData();
  }

  onDateRangeSelected() {
    this.filterData();
  }

  filterData() {
    this.trainings = filterTrainings(this.items, this.filterPanel);
  }

  getLegendaColor(status: EventStatus) {
    return StatusHelper.getStatusColor(status);
  }
}

